import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AnalysisProvider } from "@/contexts/AnalysisContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import LenderDirectory from "@/pages/LenderDirectory";
import LenderProfile from "@/pages/LenderProfile";
import LenderForm from "@/pages/LenderForm";
import DealPricing from "@/pages/DealPricing";
import UserManagement from "@/pages/UserManagement";
import AuditLog from "@/pages/AuditLog";
import AdminPanel from "@/pages/AdminPanel";
import PendingProposals from "@/pages/PendingProposals";
import ApiKeys from "@/pages/ApiKeys";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AnalysisProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<LenderDirectory />} />
              <Route path="lenders" element={<LenderDirectory />} />
              <Route path="lenders/new" element={<ProtectedRoute adminOnly allowLeader><LenderForm /></ProtectedRoute>} />
              <Route path="lenders/:id" element={<LenderProfile />} />
              <Route path="lenders/:id/edit" element={<LenderForm />} />
              <Route path="pricing" element={<DealPricing />} />
              <Route path="proposals" element={<PendingProposals />} />
              <Route path="admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
              <Route path="admin/users" element={<ProtectedRoute adminOnly><UserManagement /></ProtectedRoute>} />
              <Route path="admin/api-keys" element={<ProtectedRoute adminOnly><ApiKeys /></ProtectedRoute>} />
              <Route path="admin/audit" element={<ProtectedRoute adminOnly><AuditLog /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </AnalysisProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
